import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDragHandleGroup: React.FC<SvgProps> = (props) => {
  const color = toSvgColor('#9DA0A3', props);

  return (
    <g fill={color} {...(props.group ?? {})}>
      {/* First column of dots */}
      <circle cx="3" cy="3" r="1.5" />
      <circle cx="3" cy="8" r="1.5" />
      <circle cx="3" cy="13" r="1.5" />

      {/* Second column of dots */}
      <circle cx="8" cy="3" r="1.5" />
      <circle cx="8" cy="8" r="1.5" />
      <circle cx="8" cy="13" r="1.5" />
    </g>
  );
};

export const IconDragHandleSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconDragHandleGroup {...props} />
    </svg>
  );
};
